module.exports = __webpack_public_path__ + "static/triangle_background3-06efb33120727cd847c6d223bd68dade.jpg";